<template>
    <header class="rn-header haeder-default header--sticky">
        <div class="container">
            <div class="header-inner" style="display: flex;align-items: center;">
                <div class="header-left">
                    <logo />
                    <div class="mainmenu-wrapper" style="display: flex;align-items: center;">

                        <nav class="mainmenu-nav d-none d-xl-block">

                            <Nav :hide-app-btn="true" />

                        </nav>

                        <!-- APP 下载：桌面端独立黄色按钮（移动端菜单保持原有列表，此按钮隐藏） -->
                        <router-link to="/blog-col-two" class="header-app-btn d-none d-xl-inline-flex">
                            <i class="feather-download" />
                            <span>APP</span>
                        </router-link>
                    </div>
                </div>
                <div class="header-right">
                    <div class="setting-option d-none ">
                        <form class="search-form-wrapper" action="#" style="display: flex;">
                            <SelectDropdown style="width: 50px;" />
                        </form>

                    </div>
                    <div class="setting-option rn-icon-list d-block d-lg-none">

                        <!-- <div class="icon-box search-mobile-icon">
                            <button @click.prevent="
                                AppFunctions.toggleClass('.large-mobile-blog-search', 'active'),
                                isMobileSearchActive = !isMobileSearchActive
                            ">
                                <i :class="isMobileSearchActive ? 'feather-x' : 'feather-search'"/>
                            </button>
                        </div> -->
                        <!-- <form id="header-search-1" action="#" method="GET" class="large-mobile-blog-search">
                            <div class="rn-search-mobile form-group">
                                <button type="submit" class="search-button"><i class="feather-search"/></button>
                                <input type="text" placeholder="Search ...">
                            </div>
                        </form> -->
                    </div>
                    <!-- <div class="setting-option header-btn rbt-site-header flex-shrink-0" id="rbt-site-header">
                        <div class="icon-box">
                            <router-link id="connectbtn" class="btn btn-primary-alta btn-small" to="/connect">Wallet connect</router-link>
                        </div>
                    </div> -->
                    <!-- <div class="setting-option rn-icon-list notification-badge">
                        <div class="icon-box">
                            <router-link to="/activity"><i class="feather-bell"/><span class="badge">6</span></router-link>
                        </div>
                    </div> -->
                    <div class="header_admin">
                        <div class="setting-option rn-icon-list user-account">
                            <div class="icon-box">
                                <router-link to="/">
                                    <img :src="require(`@/assets/images/icons/boy-avater.png`)" alt="Images">
                                </router-link>
                                <div class="rn-dropdown">
                                    <div class="rn-inner-top">
                                        <h4 class="title">
                                            <router-link to="/">Christopher William</router-link>
                                        </h4>
                                        <span>
                                            <router-link to="#">Set Display Name</router-link>
                                        </span>
                                    </div>
                                    <div class="rn-product-inner">
                                        <ul class="product-list">
                                            <li class="single-product-list">
                                                <div class="thumbnail">
                                                    <router-link to="/">
                                                        <img :src="require(`@/assets/images/portfolio/portfolio-07.jpg`)"
                                                            alt="Nft Product Images">
                                                    </router-link>
                                                </div>
                                                <div class="content">
                                                    <h6 class="title">
                                                        <router-link to="/">Balance</router-link>
                                                    </h6>
                                                    <span class="price">25 ETH</span>
                                                </div>
                                                <div class="button"></div>
                                            </li>
                                            <li class="single-product-list">
                                                <div class="thumbnail">
                                                    <router-link to="/">
                                                        <img :src="require(`@/assets/images/portfolio/portfolio-01.jpg`)"
                                                            alt="Nft Product Images">
                                                    </router-link>
                                                </div>
                                                <div class="content">
                                                    <h6 class="title">
                                                        <router-link to="/">Balance</router-link>
                                                    </h6>
                                                    <span class="price">25 ETH</span>
                                                </div>
                                                <div class="button"></div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="add-fund-button mt--20 pb--20">
                                        <router-link class="btn btn-primary-alta w-100" to="/">Add Your More Funds
                                        </router-link>
                                    </div>
                                    <ul class="list-inner">
                                        <li>
                                            <router-link to="/">My Profile</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/">Edit Profile</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/">Manage funds</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/">Sign Out</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="setting-option mobile-menu-bar d-block d-xl-none">
                        <div class="hamberger">
                            <button class="hamberger-button"

                                @click="AppFunctions.addClass('.popup-mobile-menu', 'active')">
                                <i class="feather-menu" />
                                
                            </button>
                            
                        </div>
                    </div>
                    <div class="setting-option mobile-menu-bar ">
                        <div class="hamberger">
                            <SelectDropdown style="width: 45px;" />
                        </div>
                    </div>
                   
                    <!-- <div class="my_switcher setting-option">
                        <ul>
                            <li>
                                <a href="#" data-theme="light" class="setColor light"
                                    @click.prevent="AppFunctions.addClass('body', 'active-light-mode'), AppFunctions.removeClass('body', 'active-dark-mode')">
                                    <img class="sun-image" :src="require(`@/assets/images/icons/sun-01.svg`)"
                                        alt="Sun images">
                                </a>
                            </li>
                            <li>
                                <a href="#" data-theme="dark" class="setColor dark"
                                    @click.prevent="AppFunctions.addClass('body', 'active-dark-mode'), AppFunctions.removeClass('body', 'active-light-mode')">
                                    <img class="Victor Image" :src="require(`@/assets/images/icons/vector.svg`)"
                                        alt="Vector Images">
                                </a>
                            </li>
                            
                        </ul>
                    </div> -->
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import Nav from './Nav';
import AppFunctions from '../../../helpers/AppFunctions';
import Logo from "@/components/logo/Logo";
import SelectDropdown from './SelectDropdown.vue'
export default {
    name: 'Header',
    components: { Logo, Nav, SelectDropdown },
    data() {
        return {
            AppFunctions,
            isMobileSearchActive: false,
            langOptions: ['中文', 'English'], // 越南语暂时下线
            selectedLang:''
        }
    },
    mounted() {
        const header = document.querySelector('.header--sticky');
  
        const setStickyHeader = () => {
            const scrollPos = window.scrollY;
            if (scrollPos > 50) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }
        }
        window.addEventListener('scroll', setStickyHeader);
    }
}
</script>

<style scoped lang="scss">
/* 头部导航选项整体居中：在「logo 右侧 ↔ 语言图标左侧」的区间内居中，
   英文等长文案下不会贴住 logo 或右侧图标（仅桌面端显示导航时生效） */
@media (min-width: 1200px) {
    .mainmenu-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 235px;   /* 左侧让出 logo 区域 */
        right: 130px;  /* 右侧让出语言切换图标 */
        justify-content: center;
        margin: 0;
        min-height: 85px;
    }
}

/* APP 下载按钮：桌面端独立黄色胶囊（<1200px 由 bootstrap d-* 隐藏，移动端菜单不变） */
.header-app-btn {
    align-items: center;
    gap: 6px;
    margin-left: 1.5rem;
    padding: 0 18px;
    height: 40px;
    border-radius: 8px;
    background: #F3B701;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    i {
        font-size: 15px;
        line-height: 1;
        color: #fff;
    }

    &:hover {
        color: #fff;
        box-shadow: 0 0 18px rgba(255, 210, 0, 0.5);
        transform: translateY(-1px);
    }
}
</style>